import { Alert, StatusDot } from "@/shared/rd";
import { keys } from "@/lib/i18n/portal";
import { useTranslations } from "@/lib/i18n/intl";
import { sanitizedJson, snapshotRows } from "../services/selection";
import type { RealSimulatorRun } from "../types/real-simulator.types";
import { CheckList } from "./SimulationResult";
import { RealSimulatorState } from "./RealSimulatorState";
import { SimCard, Technical } from "./SimulatorParts";
const copy = keys.integrationSimulator;
export function RealSimulatorResult({ result, currency = "EGP" }: { result: RealSimulatorRun; currency?: string }) {
  const t = useTranslations();
  const rows = result.before && result.after ? snapshotRows(result.before, result.after) : [];
  const businessChanged = rows.some(row => !row.field.startsWith("counts.") && sanitizedJson(row.before) !== sanitizedJson(row.after));
  const verified = result.passed && !result.uncertain;
  return <SimCard>
    <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
      <StatusDot tone={result.uncertain ? "amber" : result.acceptance?.accepted ? "green" : "red"}>{t(result.uncertain ? copy.real.uncertain : result.acceptance?.accepted ? copy.accepted : copy.rejected)}</StatusDot>
      <StatusDot tone={verified ? "green" : "amber"}>{t(verified ? copy.real.verified : copy.real.notVerified)}</StatusDot>
      <StatusDot tone={businessChanged ? "blue" : "grey"}>{t(result.after ? businessChanged ? copy.stateChanged : copy.stateUnchanged : copy.real.readUnavailable)}</StatusDot>
      {result.acceptance ? <span className="rd-num" style={{ fontSize: 13, color: "var(--rd-text-secondary)" }}>{t(copy.real.httpStatus, { status: result.acceptance.httpStatus })}</span> : null}
    </div>
    <p style={{ margin: 0, fontSize: 13, color: "var(--rd-text-secondary)" }}>{t(copy.real.acceptanceNote)}</p>
    {result.uncertain ? <Alert tone="warn">{t(copy.real.uncertainNote)}</Alert> : null}
    <RealSimulatorState before={result.before} after={result.after} currency={currency} />
    <Technical summary={t(copy.serverDetails)} before={<CheckList checks={result.checks} />}>{sanitizedJson({ acceptance: result.acceptance, before: result.before, after: result.after, checks: result.checks, limits: result.limits })}</Technical>
  </SimCard>;
}
